import { jsxs as p, jsx as s } from "react/jsx-runtime";
import { forwardRef as W, useState as w, useRef as q, useEffect as l } from "react";
import { tv as z } from "tailwind-variants";
import C from "./Markdown.js";
import D from "./MarkdownHelp.js";
import F from "./Tabs.js";
import G from "./TextInput.js";
import J from "./ImageUpload.js";
import K from "./useModal.js";
import O from "./usePrevious.js";
const Q = z({
  slots: {
    wrapper: ["flex", "flex-col", "gap-3", "min-h-[22rem]"],
    input: ["bg-white", "grow", "p-3", "rounded-md", "font-mono"]
  },
  variants: {
    activeTab: {
      preview: {
        input: ["hidden"]
      }
    }
  }
}), { wrapper: U, input: V } = Q(), X = W(
  ({
    ariaDescribedby: v,
    ariaLabel: b,
    componentMap: x,
    defaultValue: h,
    id: g,
    maxLength: T,
    name: N,
    onChange: n,
    onImageUpload: a,
    placeholder: S,
    rows: $,
    supportsEmbeds: y,
    supportsImages: M,
    value: c,
    withExtendedFeatures: k
  }, i) => {
    const m = K(), [r, E] = w("write"), [e, u] = w(h), t = q(), P = O(r);
    l(() => {
      i == null || i({ focus: () => t.current.focus() });
    }, [i]);
    const d = (o) => {
      u(o), n == null || n(o);
    }, j = async (o, Y, I) => {
      const R = await a(o), f = t.current.selectionStart, A = t.current.selectionEnd, B = e.slice(0, f).trimEnd(), H = e.slice(A).trimStart(), L = `${f ? `

` : ""}![${o.alt}](${R})

`;
      m.close(), I.reset(), d(`${B}${L}${H}`), t.current.focus();
    };
    return l(() => {
      c !== e && u(c);
    }, [c]), l(() => {
      P && r !== "preview" && t.current.focus();
    }, [r]), /* @__PURE__ */ p("div", { className: U(), children: [
      /* @__PURE__ */ p("div", { className: "flex flex-wrap gap-4 items-center justify-between", children: [
        /* @__PURE__ */ s(
          F,
          {
            activeTab: r,
            ariaLabel: "Select write or preview mode",
            onChange: E,
            options: [
              {
                label: "Write",
                value: "write"
              },
              {
                label: "Preview",
                value: "preview"
              }
            ]
          }
        ),
        /* @__PURE__ */ p("div", { className: "flex gap-4", children: [
          a && /* @__PURE__ */ s(J, { modal: m, onSubmit: j }),
          /* @__PURE__ */ s(D, {})
        ] })
      ] }),
      /* @__PURE__ */ s(
        G,
        {
          ariaDescribedby: v,
          ariaLabel: b,
          className: V({ activeTab: r }),
          id: g,
          maxLength: T,
          name: N,
          onChange: d,
          placeholder: S,
          ref: t,
          rows: $,
          type: "textarea",
          value: e
        }
      ),
      r === "preview" && /* @__PURE__ */ s(
        C,
        {
          className: "border border-neutral-200 grow rounded-md p-3",
          componentMap: x,
          supportsImages: M || !!a,
          supportsEmbeds: y,
          withExtendedFeatures: k,
          children: e == null ? void 0 : e.replace(/\n?<!--[^>]*-->/g, "")
        }
      )
    ] });
  }
);
X.displayName = "MarkdownPreview";
export {
  X as default
};
